export const CLIENT_ID = import.meta.env.VITE_GATEHAUS_CLIENT_ID ?? 'gatehaus';
